module.exports = __webpack_public_path__ + "static/media/walid-bg.143bf800.png";